/*
 * NxtChair offerte-lade — verzamelt configuraties (localStorage), toont ze in een
 * uitschuifpaneel, en verstuurt de volledige lijst via submitQuoteRequest().
 * Geen Shopify-cart/checkout. window.NxtQuote is het publieke API.
 */
(function () {
  'use strict';

  var T = (window.NXT_I18N || {});
  var KEY = 'nxtchair_quote_v1';
  var confirming = false; /* bevestiging staat in beeld: render() mag die niet wegschrijven */
  var EUR = function (n) { return '\u20ac\u00a0' + Number(n).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { localStorage.setItem(KEY, JSON.stringify(list)); render(); }

  var NxtQuote = {
    lines: read(),
    add: function (line) { this.lines = read(); this.lines.push(Object.assign({ id: Date.now() + '-' + Math.random().toString(36).slice(2, 7) }, line)); write(this.lines); this.open(); },
    remove: function (id) { this.lines = read().filter(function (l) { return l.id !== id; }); write(this.lines); },
    clear: function () { this.lines = []; write(this.lines); },
    open: function () { var d = document.getElementById('ncq-drawer'); if (d) { d.classList.add('open'); document.getElementById('ncq-backdrop').classList.add('open'); document.documentElement.style.overflow = 'hidden'; } },
    close: function () {
      confirming = false; var d = document.getElementById('ncq-drawer'); if (d) { d.classList.remove('open'); document.getElementById('ncq-backdrop').classList.remove('open'); document.documentElement.style.overflow = ''; } }
  };
  window.NxtQuote = NxtQuote;

  /* Regel-thumbnail: productfoto met de gekozen kleur/stof als badge erop.
     Zonder foto valt hij terug op alleen de kleurstaal. */
  function thumb(l) {
    var sw = l.swatchImg
      ? '<span style="position:absolute;right:-3px;bottom:-3px;width:18px;height:18px;border-radius:50%;overflow:hidden;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.25)"><img src="' + l.swatchImg + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block"></span>'
      : (l.hex ? '<span style="position:absolute;right:-3px;bottom:-3px;width:18px;height:18px;border-radius:50%;background:' + l.hex + ';border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.25)"></span>' : '');
    if (l.img) {
      return '<span style="position:relative;flex:none;width:46px;height:46px;display:inline-block">'
        + '<span style="display:block;width:46px;height:46px;border-radius:8px;overflow:hidden;background:#fff;border:1px solid #E5E3DC">'
        + '<img src="' + l.img + '" alt="" style="width:100%;height:100%;object-fit:contain;display:block"></span>' + sw + '</span>';
    }
    return '<span style="position:relative;flex:none;width:46px;height:46px;display:inline-block">'
      + '<span style="display:block;width:46px;height:46px;border-radius:8px;background:' + (l.hex || '#1A1A1A') + ';border:1px solid #E5E3DC"></span></span>';
  }

  function render() {
    if (confirming) return;
    var list = read();
    var count = list.reduce(function (s, l) { return s + (parseInt(l.qty, 10) || 0); }, 0);
    // badge
    Array.prototype.forEach.call(document.querySelectorAll('[data-ncq-badge]'), function (b) {
      if (list.length > 0) { b.textContent = list.length; b.style.display = 'flex'; } else { b.style.display = 'none'; }
    });
    var body = document.getElementById('ncq-body'); if (!body) return;
    var footer = document.getElementById('ncq-footer');
    if (list.length === 0) {
      body.innerHTML = '<div style="padding:48px 24px;text-align:center"><p style="font-size:15px;color:#4A4A46;margin:0 0 18px">' + (T.lade_leeg || 'Nog geen configuraties toegevoegd aan je offerte-aanvraag.') + '</p><a href="/pages/collectie" class="ncq-btn ncq-btn--g" style="text-decoration:none">Naar de collectie</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var total = 0, html = '';
    list.forEach(function (l) {
      var hideP = (window.NXT_SHOW_PRICES === false) || l.priceHidden;
      var lt = hideP ? 0 : ((l.total != null) ? l.total : ((l.unit || 0) * (l.qty || 0)));
      total += lt;
      var priceStr = hideP ? '' : (l.priceLabel ? l.priceLabel : EUR(lt));
      html += '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:16px 0;border-bottom:1px solid #E5E3DC">'
        + '<div style="display:flex;align-items:flex-start;gap:12px">'
        + thumb(l)
        + '<div><div style="font-weight:500;font-size:14px;line-height:1.4">' + (l.label || T.configuratie || 'Configuratie') + '</div>'
        + '<div style="font-size:12px;color:#8C8A82;margin-top:3px">' + (l.qty || 0) + ' ' + (T.stuks || 'stuks') + ((l.unit && !hideP) ? ' \u00b7 ' + EUR(l.unit) + ' ' + (T.per_stuk_kort || 'p/st') : '') + '</div></div></div>'
        + '<div style="text-align:right;display:flex;flex-direction:column;align-items:flex-end;gap:8px">'
        + '<div style="font-weight:700;font-size:14px;white-space:nowrap">' + priceStr + '</div>'
        + '<button data-ncq-remove="' + l.id + '" aria-label=' + JSON.stringify(T.verwijderen || 'Verwijderen') + ' style="width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;color:#8C8A82"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px"><path d="M4 6h12"/><path d="M8 6V4.5h4V6"/><path d="M6 6l.7 10h6.6L14 6"/></svg></button>'
        + '</div></div>';
    });
    body.innerHTML = html;
    if (footer) {
      footer.style.display = 'block';
      var totalEl = document.getElementById('ncq-total'); if (totalEl) totalEl.textContent = EUR(total);
      var totalRow = totalEl ? totalEl.parentNode : null; if (totalRow) totalRow.style.display = (window.NXT_SHOW_PRICES === false) ? 'none' : '';
      var cntEl = document.getElementById('ncq-count'); if (cntEl) cntEl.textContent = count;
      var lbl = document.getElementById('ncq-totaal-label');
      if (lbl) lbl.textContent = (lbl.getAttribute('data-tpl') || '').replace('__N__', count);
    }
  }

  function submit(e) {
    var list = read();
    var form = document.getElementById('ncq-form');
    var org = (document.getElementById('ncq-org') || {}).value.trim();
    var email = (document.getElementById('ncq-email') || {}).value.trim();
    var tel = (document.getElementById('ncq-tel') || {}).value.trim();
    if (list.length === 0) { if (e) e.preventDefault(); alert(T.offerte_leeg_waarschuwing || 'Je offerte-aanvraag is nog leeg. Voeg eerst een configuratie toe.'); return; }
    if (!org || !email || !tel) { return; } // native required-validatie handelt lege velden af
    // vul het verborgen body-veld met alle regels en laat het native Shopify-formulier posten
    var bodyField = document.getElementById('ncq-body-field');
    if (bodyField) bodyField.value = buildBody({ organisatie: org, email: email, telefoon: tel, lines: list });
    try { localStorage.setItem('nxtchair_quote_sent', '1'); } catch (err) {}
    try { localStorage.removeItem(KEY); } catch (err) {}
    // formulier post nu regulier (geen preventDefault) -> Shopify mailt naar het contact-notificatieadres
  }

  function buildBody(p) {
    var lines = p.lines.map(function (l, i) {
      return (i + 1) + '. ' + (l.label || T.configuratie || 'Configuratie') + ' — ' + (l.qty || 0) + ' ' + (T.stuks || 'stuks') + ((l.unit && !l.priceHidden && window.NXT_SHOW_PRICES !== false) ? ' a ' + EUR(l.unit) : '') + ((l.total && !l.priceHidden && window.NXT_SHOW_PRICES !== false) ? ' = ' + EUR(l.total) : '');
    }).join('\n');
    return (T.mail_kop || 'OFFERTE-AANVRAAG (via offerte-lade)') + '\n\n' + (T.mail_bedrijfsnaam || 'Bedrijfsnaam') + ': ' + p.organisatie + '\n' + (T.mail_email || 'E-mail') + ': ' + p.email + '\n' + (T.mail_telefoon || 'Telefoon') + ': ' + p.telefoon + '\n\n' + (T.mail_configuraties || 'Configuraties') + ':\n' + lines + '\n\n(Alle prijzen indicatief, excl. btw & transport.)';
  }

  function bind() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-ncq-open]');
      if (open) { e.preventDefault(); NxtQuote.open(); return; }
      if (e.target.closest('[data-ncq-close]')) { NxtQuote.close(); return; }
      var rm = e.target.closest('[data-ncq-remove]');
      if (rm) { NxtQuote.remove(rm.getAttribute('data-ncq-remove')); return; }
      var frm = e.target.closest && e.target.closest('#ncq-form'); // laat native submit lopen
    });
    var qform = document.getElementById('ncq-form');
    if (qform) qform.addEventListener('submit', submit);
    // bevestiging tonen na de Shopify-redirect (?contact_posted=true) als de aanvraag uit de lade kwam
    var sent = false; try { sent = localStorage.getItem('nxtchair_quote_sent') === '1'; } catch (e) {}
    if (sent) {
      try { localStorage.removeItem(KEY); localStorage.removeItem('nxtchair_quote_sent'); } catch (e) {}
      NxtQuote.lines = [];
      confirming = true;
      var b = document.getElementById('ncq-body'); if (b) b.innerHTML = '<div style="padding:48px 24px;text-align:center"><svg viewBox="0 0 24 24" fill="none" stroke="#5C6B0F" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="width:40px;height:40px;margin:0 auto 16px"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9"/></svg><p style="font-size:16px;font-weight:500;color:#1A1A1A;margin:0 0 6px">' + (T.bedankt_titel || 'Bedankt voor je aanvraag') + '</p><p style="font-size:14px;color:#4A4A46;margin:0">' + (T.bedankt_tekst || 'We reageren binnen 1 werkdag op je offerte-aanvraag.') + '</p></div>';
      var f = document.getElementById('ncq-footer'); if (f) f.style.display = 'none';
      Array.prototype.forEach.call(document.querySelectorAll('[data-ncq-badge]'), function (x) { x.style.display = 'none'; });
      NxtQuote.open();
    }
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', render);
})();
